export default __webpack_public_path__ + "static/media/safety_commissioning_character.42dc3e71.svg";